import { SpaceProps, Text, useColorModeValue } from "@chakra-ui/react";
import { WithChildren } from "types";

const SectionHeader = ({
  children,
  ...spaceProps
}: WithChildren & SpaceProps) => {
  const color = useColorModeValue(
    "var(--chakra-colors-gray-600)",
    "var(--chakra-colors-gray-100)"
  );

  return (
    <Text
      mt={spaceProps.mt}
      mb={spaceProps.mb}
      fontSize="md"
      color={color}
      fontWeight="semibold"
    >
      {children}
    </Text>
  );
};

export { SectionHeader };
